import { AnalogLink } from '@paragon/contract-library';

export const getAnalogLinksForMember = (memberGuid: string, analogLinks: ReadonlyArray<AnalogLink>) => {
  const analogLinksWithMemberGuid: AnalogLink[] = [];
  for (const analogLink of analogLinks) {
    if (analogLink.memberStack.memberGuids.includes(memberGuid)) {
      analogLinksWithMemberGuid.push(analogLink);
    }
  }
  return analogLinksWithMemberGuid;
};
